import { useEffect } from "react";

interface Script {
  type: string;
  id: string;
  async: boolean;
  defer: boolean;
  src: string;
}

const scripts: Script[] = [
  // {
  //   type: "text/javascript",
  //   id: "hs-script-loader",
  //   async: true,
  //   defer: true,
  //   src: "https://js-na1.hs-scripts.com/22105034.js",
  // },
  {
    type: "text/javascript",
    id: "butterfly-js",
    async: true,
    defer: false,
    src: `https://app.butterflye.io/assets/sdk/v1/butterflye-sdk.js`,
  },
  {
    type: "text/javascript",
    id: "usersnap-js",
    async: true,
    defer: true,
    src: "https://widget.usersnap.com/global/load/c2e6d79b-6290-460f-b136-a4edef891209?onload=onUsersnapLoad",
  },
];

export const useLoadScripts = () => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      for (const script of scripts) {
        const scriptElement = document.createElement("script");
        scriptElement.type = script.type;
        scriptElement.id = script.id;
        scriptElement.async = script.async;
        scriptElement.defer = script.defer;
        scriptElement.src = script.src;
        document.body.appendChild(scriptElement);
      }
    }, 2000);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }

      for (const script of scripts) {
        const scriptElement = document.getElementById(script.id);
        if (scriptElement) {
          scriptElement.remove();
        }
      }
    };
  }, []);
};
